<template>
  <details @toggle="collapsed = !collapsed" :open="collapsed">
    <summary>
      <span v-html="question"></span>
      <BaseIcon icon="keyboard_arrow_up" class="arrow" v-if="collapsed" />
      <BaseIcon icon="keyboard_arrow_down" class="arrow" v-else />
    </summary>
    <span v-html="answer"></span>
  </details>
</template>
<script setup lang="ts">
defineProps<{
  question: string;
  answer: string;
}>();

const collapsed = ref(false);
</script>
<style lang="scss" scoped>
details {
  background-color: $light-95;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid $light-80;
}

details summary {
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  list-style: none;
  &::-webkit-details-marker {
    display: none;
  }
}

.arrow {
  color: $dark-50;
  font-size: 3rem;
  width: fit-content;
  height: fit-content;
}

a {
  color: $gold;
}
</style>
